import { CallToActionProps } from "@omni/ui/components/CallToAction/callToAction.props";
import { CallToActionType } from "@omni/ui/components/CallToAction/types/enums/callToActionType.enum";

import { CallToActionComponent } from "./callToAction.component";
import { CallToActionContextProvider } from "./callToAction.context";
import { ButtonCallToAction } from "./components/ButtonCallToAction/buttonCallToAction.container";
import { CallToActionContent } from "./components/CallToActionContent/callToActionContent.container";
import { LinkCallToAction } from "./components/LinkCallToAction/linkCallToAction.container";

const CallToAction = (props: CallToActionProps) => {
    const content = <CallToActionContent {...props.content} />;

    return (
        <CallToActionContextProvider
            callToActionType={props.callToActionType}
            tracking={props.tracking}
            style={props.style}
        >
            <CallToActionComponent marginClass={props.marginClass}>
                {props.callToActionType === CallToActionType.BUTTON ? (
                    <ButtonCallToAction
                        action={props.action}
                        prefetchedData={props.prefetchedData}
                    >
                        {content}
                    </ButtonCallToAction>
                ) : (
                    <LinkCallToAction link={props.link}>
                        {content}
                    </LinkCallToAction>
                )}
            </CallToActionComponent>
        </CallToActionContextProvider>
    );
};

export { CallToAction };
